import { useEffect, useCallback, useRef, useState } from 'react';

// custom hook for detecting screen size

export const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < breakpoint);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);
    return isMobile;
};
// Lazy rendering
export const useLazyRender = (data: any[], chunkSize = 10) => {
    const [visibleItems, setVisibleItems] = useState(data.slice(0, chunkSize));
    const indexRef = useRef(chunkSize);
    const loadMore = useCallback(() => {
        const next = data.slice(indexRef.current, indexRef.current + chunkSize);
        if (next.length) {
            setVisibleItems((prev) => [...prev, ...next]);
            indexRef.current += chunkSize;
        }
    }, [data, chunkSize]);
    useEffect(() => {
        setVisibleItems(data.slice(0, chunkSize));
        indexRef.current = chunkSize;
    }, [data, chunkSize]);
    return { visibleItems, loadMore };
};
// IntersectionObserver logic
export const useInfiniteScroll = (onLoadMore: () => void) => {
    const observerRef = useRef<IntersectionObserver | null>(null);
    const lastRef = useCallback(
        (node: HTMLElement | null) => {
            if (observerRef.current) observerRef.current.disconnect();
            observerRef.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    onLoadMore();
                }
            });
            if (node) observerRef.current.observe(node);
        },
        [onLoadMore]
    );
    return lastRef;
};
